import { TopUpFrequency } from '../../../../_interfaces/employee.interface';
import { CardFundType } from '../../../../_interfaces/cards.interface';
import {
  ImmediateTopUpSelectOption,
  RecurringTopUpSelectOption,
} from '../../../../shared/interfaces/project-interfaces';

export const topUpSelectOptions: RecurringTopUpSelectOption[] = [
  {
    label: 'Daily',
    checked: false,
    value: TopUpFrequency.Daily,
    name: 'dailyField',
  },
  {
    label: 'Weekly',
    checked: false,
    value: TopUpFrequency.Weekly,
    name: 'weeklyField',
  },
  {
    label: 'Monthly',
    checked: true,
    value: TopUpFrequency.Monthly,
    name: 'monthlyField',
  },
];

export const immediateTopupSelectOptions: ImmediateTopUpSelectOption[] = [
  {
    label: 'Load funds',
    checked: false,
    value: CardFundType.Load,
    name: 'load',
    icon: 'pays-svg-icon ic-card-load text-success me-1',
  },
  {
    label: 'Unload funds',
    checked: false,
    value: CardFundType.Deduct,
    name: 'deduct',
    icon: 'pays-svg-icon ic-card-unload text-danger me-1',
  },
];
